const upload = {
  computed: {
    validationAccept() {
      return 'jpg,jpeg,png,doc,docx,xls,xlsx,pdf,txt,p7s,xml'
    },
    rules() {
      const rules = 'required|size:10000|ext:'
      return rules + this.validationAccept
    },
    extensionsMap() {
      return {
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        doc: 'application/msword',
        pdf: 'application/pdf',
        txt: 'text/plain',
        png: 'image/png',
        jpeg: 'image/jpeg',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xls: 'application/vnd.ms-excel',
        p7s: 'application/pkcs7-signature',
        xml: 'text/xml'
      }
    },
    acceptedFileExtensions() {
      return Object.values(this.extensionsMap).join(',')
    }
  }
}

export default upload
